import { render } from "./CopyIcon.vue?vue&type=template&id=0ac531a6"
const script = {}
script.render = render

export default script